import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { isFramedAppearance, resolveComposerMask } from '#pplx/frontend/composer-sdk/styles.js';
import { styles as surfaceStyles } from '#pplx_generated/pplx/frontend/composer-sdk/ComposerSurface.module.css.js';
import classNames from 'classnames';
// Scope the complete fill to both legacy container portals and SDK sibling overlays.
export function getComposerSurfaceClassNames({ appearance = 'raised', mask, suggestionAttachment = 'input', }) {
    const isFramed = isFramedAppearance(appearance);
    const hasComposerFill = isFramed || (mask !== undefined && (appearance === 'raised' || appearance === 'flat'));
    let attachSuggestionsToFrame;
    switch (suggestionAttachment) {
        case 'input':
            attachSuggestionsToFrame = false;
            break;
        case 'frame':
            attachSuggestionsToFrame = isFramed;
            break;
        default:
            return assertUnreachableValue(suggestionAttachment);
    }
    const resolvedMask = resolveComposerMask(mask ?? 'base');
    const darkFrameBacking = {
        base: 'dark:[--composer-frame-suggestion-backing:var(--bg-base)]',
        raised: 'dark:[--composer-frame-suggestion-backing:var(--bg-raised)]',
        transparent: 'dark:[--composer-frame-suggestion-backing:transparent]',
    };
    return classNames(hasComposerFill
        ? [
            appearance === 'framed-accent'
                ? surfaceStyles.suggestionHostAccent
                : surfaceStyles.suggestionHost,
            resolvedMask.dark === 'raised'
                ? '[--composer-surface-backing:var(--bg-raised)]'
                : '[--composer-surface-backing:var(--bg-base)]',
        ]
        : '[--composer-suggestion-background:initial]', attachSuggestionsToFrame
        ? [
            appearance === 'framed-accent'
                ? surfaceStyles.frameSuggestionHostAccent
                : surfaceStyles.frameSuggestionHost,
            resolvedMask.light === 'raised'
                ? '[--composer-frame-suggestion-backing:var(--bg-raised)]'
                : '[--composer-frame-suggestion-backing:var(--bg-base)]',
            // Unmasked frames keep the light base backing but stay transparent in dark mode.
            darkFrameBacking[mask === undefined ? 'transparent' : resolvedMask.dark],
        ]
        : // Stop inherited frame fills at input-attached hosts.
            '[--composer-frame-suggestion-background:initial]');
}
//# sourceMappingURL=surfaceStyles.js.map